import { AuthProvider, AuthProviderProps, useAuth,  } from 'oidc-react';
import * as React from 'react';
import App from './App';

const config: AuthProviderProps = {
    authority:
        'https://login.microsoftonline.com/3bea478c-1684-4a8c-8e85-045ec54ba430/v2.0',
    clientId: '31a86d4a-6fac-427a-ad39-a0f21c9e8d40',
    loadUserInfo: false,
    redirectUri: `${window.location.origin}/callback`,
    onSignIn: () => history.replaceState(null, '', '/'),
    responseType: 'code',
    scope: 'openid email profile https://graph.microsoft.com/Mail.Read https://graph.microsoft.com/User.Read'
};

const AuthCheck = (props) => {
    const auth = useAuth();
    if (auth.isLoading) {
        return (
            <div className='container'>
                <h1>Emails</h1>
                Authenticating...
            </div>
        );
    } else {
        return props.children;
    }
}

const AppWithAuth = () => <AuthProvider {...config}><AuthCheck><App/></AuthCheck></AuthProvider>;

export default AppWithAuth;
